<template>
  <div class="chat-bubble bot products" :id="this.messageId + '-products'">
    <div class="bot-profilepic">
      <i class="mm-icon favicon-mm-stitches">
        <svg role="presentation"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="icon"
          aria-hidden="true">
          <use href="#favicon-mm-stitches" />
        </svg>
      </i>
    </div>

    <div class="message px-0">
      <div class="container-fluid px-0">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide product-chatbot-tile flex-column col-3" v-for="(product, indexP) in this.products">
              <a :href="product.url" target="_blank" class="tile-link" @click="triggerClickEventOnProduct(product)">
                <div class="product-image">
                  <img :src="image.url" :key="i" :class="product.images.length > 1 ? 'image-'+i : 'image'" class="img-fluid" alt="" v-for="(image, i) in product.images">
                </div>
                <div class="product-name">{{ product.name }}</div>
                <div class="product-price">{{ product.price }}</div>
                <!-- <div class="product-selected-color">{{ product.color.selected.colorName }}</div>
                <div class="product-colors mb-1">
                  <template v-for="(color, indexC) in product.color.allColorAttributes">
                    <div class="color-swatch" :class="{'selected': color.selected }" v-if="indexC < 4" :style="{ 'background-color': color.hex }"></div>
                    <div class="plus" v-if="indexC === 5"> +{{ (product.color.allColorAttributes.length + 1) - indexC }}</div>
                  </template>
                </div> -->
              </a>
              <button
                v-if="(!product.fromHistory && this.messageId === this.totalMessages) || (product.fromHistory && this.messageId === this.totalMessages)"
                type="button"
                class="mm-button like-product-button -block"
                :disabled="this.likedProductIndex"
                :class="{'selected-product': this.likedProductIndex === indexP}"
                @click="likeProductEmit({id: product.id, name: product.name, index: indexP, raw: product.raw})">
                <span>{{ this.$translations.buttons.like }}</span>
              </button>
            </div>
          </div>
          <div class="swiper-button-prev-products swiper-arrow swiper-button-prev"></div>
          <div class="swiper-button-next-products swiper-arrow swiper-button-next"></div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Swiper, {Navigation, Pagination} from 'swiper';
Swiper.use([Navigation, Pagination]);

export default {
  data() {
    return {
      likedProductIndex: null
    }
  },
  props: [
    'messageId',
    'products',
    'totalMessages'
  ],
  emits: ['likeProduct', 'clickedProduct'],
  methods: {
    likeProductEmit(product) {
      this.likedProductIndex = product.index;
      this.$emit('likeProduct', product);
    },
    triggerClickEventOnProduct(product) {
      this.$emit('clickedProduct', product);
    }
  },
  mounted(){
    setTimeout(() => {
      // this timeout is needed to correctly render the slider after the message rendering -- just 1ms of delay is enough
      const swiper = new Swiper('.swiper-container', {
        speed: 400,
        spaceBetween: 10,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next-products',
          prevEl: '.swiper-button-prev-products',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
      });
    }, 1);
  }
}
</script>
